import { render, staticRenderFns } from "./CommentOnHold.vue?vue&type=template&id=4cc51ad8&scoped=true&"
import script from "./CommentOnHold.vue?vue&type=script&lang=js&"
export * from "./CommentOnHold.vue?vue&type=script&lang=js&"
import style0 from "./CommentOnHold.vue?vue&type=style&index=0&id=4cc51ad8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc51ad8",
  null
  
)

export default component.exports